import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
/*
Generated class for the CalendarioProvider provider.

See https://angular.io/guide/dependency-injection for more info on providers
and Angular DI.
*/
@Injectable()
export class CalendarioProvider {
  items: any;
  constructor(
    public http: HttpClient
  ) {
    this.getDizionario();
    this.getMeteo();
    this.items = [
      {title: 'one'},
      {title: 'two'},
      {title: 'three'},
      {title: 'four'},
      {title: 'five'},
      {title: 'six'}
    ]
  }
  calendario:any = {}
  mercolediDiverso:any = [];
  dizionarioJSON:any;

  filterItems(searchTerm){
    return this.dizionarioJSON.filter((item) => {
      return item.nomeProdotto.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });

  }
  getDati(){

    //TODO forse non c'è bisogno dell chiamata http per i comunicati si
    //vedo di farlo con firebase così evitiamo altervista che è lento
    this.calendario = [
      {
        "giorno": "Domenica",
        "abbr": "Dom",
        "messaggio": " RIFIUTI ORGANICI E UMIDO",
        "messaggioDomani": "domani sera puoi depositare IMBALLAGGI IN PLASTICA"
      },
      {
        "giorno": "Lunedì",
        "abbr": "Lun",
        "messaggio": " IMBALLAGGI IN PLASTICA",
        "messaggioDomani": "domani sera puoi depositare RIFIUTI ORGANICI UMIDO, CARTA E CARTONE"
      },
      {
        "giorno": "Martedì",
        "abbr": "Mar",
        "messaggio": " RIFIUTI ORGANICI UMIDO CARTA E CARTONE",
        "messaggioDomani": "domani sera puoi depositare IMBALLAGGI IN METALLO"
      },
      {
        "giorno": "Mercoledì",
        "abbr": "Mer",
        "messaggio": " IMBALLAGGI IN VETRO",
        "messaggioDomani": "domani sera puoi depositare RIFIUTI ORGANICI E UMIDO"
      },
      {

        "giorno": "Giovedì",
        "abbr": "Gio",
        "messaggio": " RIFIUTI ORGANICI E UMIDO",
        "messaggioDomani": "domani sera puoi depositare SECCO RESIDUALE NON RICICLABILE"

      },
      {

        "giorno": "Venerdì",
        "abbr": "Ven",
        "messaggio": " SECCO RESIDUALE NON RICICLABILE",
        "messaggioDomani": "domani sera puoi SERA NON PUOI depositareRE RIFIUTI"

      },
      {
        "giorno": "Sabato",
        "abbr": "Sab",
        "messaggio": " non puoi depositarere rifiuti",
        "messaggioDomani": "domani sera puoi depositare RIFIUTI ORGANICI UMIDO"
      }
    ]

  }
  icon:any;
  temp_c:any;
  temp_cFor:any;
  iconFor:any;
  umidita:any;
  tempMaxFor:any;
  tempMinFor:any;

  getMeteo(){

  }
  getDizionario(param?){
    return new Promise(resolve => {
      this.http.get('https://strianodifferenziamoci.firebaseio.com/.json').subscribe(data => {
        resolve(data);
        this.dizionarioJSON = data;
        return data;
      }, err => {
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/calendario/calendario.ts